// Customer management types
import type { Json } from './database.generated'

export interface Customer {
  id: string
  organization_id: string
  name: string
  company_code: string | null
  contact_email: string | null
  contact_phone: string | null
  address: string | null
  country: string | null
  industry: string | null
  description: string | null
  configuration_notes: string | null
  agent_instructions: string | null
  metadata: Json | null
  is_active: boolean | null
  created_at: string
  updated_at: string
  created_by: string | null
}

export interface CustomerEntity {
  id: string
  organization_id: string
  customer_id: string
  name: string
  entity_code: string | null
  d365_version: string | null
  d365_products: string[] | null
  d365_deployment_type: 'cloud' | 'on_premises' | 'cloud_hosted_dev' | null
  environment_type: 'production' | 'sandbox' | 'development' | 'test' | null
  lcs_project_id: string | null
  environment_url: string | null
  description: string | null
  metadata: Json | null
  is_active: boolean | null
  created_at: string
  updated_at: string
  created_by: string | null
}

export interface CustomerUser {
  id: string
  organization_id: string
  customer_id: string
  entity_id: string | null
  name: string
  email: string | null
  phone: string | null
  job_title: string | null
  department: string | null
  is_primary_contact: boolean | null
  metadata: Json | null
  is_active: boolean | null
  created_at: string
  updated_at: string
  created_by: string | null
}

export interface CustomerWithDetails extends Customer {
  entities?: CustomerEntity[]
  users?: CustomerUser[]
  entity_count?: number
  user_count?: number
  issue_count?: number
}

export type EnvironmentType = 'production' | 'sandbox' | 'development' | 'test'

export const ENVIRONMENT_TYPES: { value: EnvironmentType; label: string }[] = [
  { value: 'production', label: 'Production' },
  { value: 'sandbox', label: 'Sandbox' },
  { value: 'development', label: 'Development' },
  { value: 'test', label: 'Test' },
]

export interface CustomerProfileDocument {
  id: string
  organization_id: string
  customer_id: string
  file_name: string
  file_type: string
  file_size_bytes: number
  storage_path: string
  storage_bucket: string
  title: string | null
  description: string | null
  uploaded_by: string | null
  category: string
  d365_version: string | null
  d365_module: string | null
  tags: string[]
  processing_status: 'pending' | 'extracting' | 'chunking' | 'embedding' | 'completed' | 'failed'
  processing_error: string | null
  chunk_count: number
  is_active: boolean
  created_at: string
  updated_at: string
  metadata: Json | null
}
